// noinspection DuplicatedCode
import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import Card from "@material-tailwind/react/Card";
import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { HrdInputGenerator } from "../../../../components/form/HrdInputGenerator";
import Skeltons from "../../../../components/loading/Skeltons";
import { SearchBarSmallV2 } from "../../../../components/form/SearchBar";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  fetchGet,
  fetchPostMultipartSeaweed,
  fetchPostSilance,
} from "../../../../fetchers";

import { sakitTransaksiSelector, updateSakitTransaksi } from "./sakitTransaksiSlice";
import { approve } from "../../../setup/approval/approvalSlice";

import { useMutation } from "@tanstack/react-query";
import { Colors } from "../../../../assets/Colors";
import { isRequired, useForm } from "../../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";
import CutiApprovalActors from "../cuti/CutiApprovalActors";

const PAGE_SIZE = 10;
const fmtTgl = (v) => (v ? new Date(v).toLocaleDateString("id-ID") : "-");
const statusClass = (s) =>
  s === "Selesai"
    ? "text-green-600 font-medium"
    : s === "Ditolak" || s === "Revisi"
    ? "text-red-600 font-medium"
    : s === "Belum Dikirim"
    ? "text-gray-500 font-medium"
    : "text-yellow-600 font-medium";

const SakitPage = ({}) => {
  let initialState = {
    Nik: "",
    JenisSakit: "",
    KeperluanSakit: "",
    TanggalSakit: new Date(),
    TanggalSembuh: new Date(),
  };
  const mutation = useMutation((param) => fetchGet("hrd/sakit", param));

  const mutationInput = useMutation((param) =>
    fetchPostSilance("hrd/sakit", param)
  );

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    ({ JenisPerawatan }) =>
      isRequired(JenisPerawatan) || {
        JenisPerawatan: "Jenis Perawatan wajib diisi",
      },
    ({ NamaRS }) => isRequired(NamaRS) || { NamaRS: "Nama RS wajib diisi" },
    ({ NamaDokter }) =>
      isRequired(NamaDokter) || { NamaDokter: "Nama Dokter wajib diisi" },
  ];

  const {
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const dispatch = useDispatch();
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageC, setPageC] = useState(1);
  const sakit = useSelector(sakitTransaksiSelector);

  useEffect(() => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  }, []);

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );

  const reapprove = () => {
    mutation.mutate({ start: 0, count: 100000, search: "" });
  };

  function handleCurrentData(values) {
    editHandler(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
  }

  // ── Data list (client-side search + pagination) ─────────────
  const allRows = useMemo(() => {
    const d = mutation.data?.data;
    return Array.isArray(d) ? d : [];
  }, [mutation.data]);

  const filtered = useMemo(() => {
    const kw = searchQuery.trim().toLowerCase();
    if (!kw) return allRows;
    return allRows.filter((r) =>
      [r.SakitID, r.Nik, r.NamaKaryawan, r.JenisPerawatan, r.NamaPenyakit, r.StatusKet].some(
        (v) => v && v.toString().toLowerCase().includes(kw)
      )
    );
  }, [allRows, searchQuery]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(pageC, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPageC(1);
  }, [searchQuery, mutation.data]);

  // ── Export (mengikuti hasil filter/search) ───────────────────
  const exportHeader = ["ID", "Nama Karyawan", "Jenis Perawatan", "Penyakit", "Tanggal Sakit", "Tanggal Sembuh", "Status Approval"];
  const exportBody = () =>
    filtered.map((r) => [
      r.SakitID || "", r.NamaKaryawan || "", r.JenisPerawatan || "", r.NamaPenyakit || "",
      fmtTgl(r.TanggalSakit), fmtTgl(r.TanggalSembuh), r.StatusKet || "",
    ]);
  const handleDownloadExcel = () => {
    downloadExcel({ fileName: "Sakit", sheet: "data", tablePayload: { header: exportHeader, body: exportBody() } });
  };
  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(13);
    doc.text("Sakit", 14, 14);
    autoTable(doc, { head: [exportHeader], body: exportBody(), startY: 20, styles: { fontSize: 7 }, headStyles: { fillColor: [30, 58, 95] } });
    doc.save("Sakit.pdf");
  };

  const colHeader = ["ID", "Nama Karyawan", "Jenis Perawatan", "Penyakit", "Tanggal Sakit", "Tanggal Sembuh", "Status Approval", "Approval", "Actions"];

  // Kirim = mulai approval rantai Setup > Approval menu "Sakit". Gagal (mis. Bagian belum
  // punya rantai) ditampilkan, bukan diam — dulu tombol ini tak pernah memberi kabar.
  const handleKirim = (sakitID) => {
    dispatch(approve({ primary: sakitID }))
      .unwrap()
      .then(() => toast.success("Data sakit dikirim untuk approval", { position: "bottom-right" }))
      .catch((e) => toast.error(e?.message || "Gagal mengirim", { position: "bottom-right" }))
      .finally(() => reapprove());
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {mutation.isLoading ? (
                  <div className="w-full pt-0"><Skeltons /></div>
                ) : (
                  <>
                    <div className="flex w-full justify-between px-4 pt-4 flex-col sm:flex-row gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={() => handleModal({ showModalAdd: true, showModalEdit: false })}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                        >
                          Tambah +
                        </button>
                        <button onClick={handleDownloadExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow">
                          Download Excel
                        </button>
                        <button onClick={handleDownloadPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow">
                          Download PDF
                        </button>
                      </div>
                      <div className="w-full sm:w-72">
                        <SearchBarSmallV2 text={"Cari Sakit"} value={searchQuery} funcs={(e) => setSearchQuery(e.target.value)} />
                      </div>
                    </div>

                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>{colHeader.map((h, i) => <th key={i} scope="col" className="py-3 px-6">{h}</th>)}</tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr><td colSpan={colHeader.length} className="text-center py-8 text-gray-400">
                              {searchQuery ? `Tidak ada data untuk "${searchQuery}"` : "Tidak ada data"}
                            </td></tr>
                          ) : (
                            pageRows.map((row, id) => (
                              <tr key={row.SakitID || id} className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                                <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">{row.SakitID}</td>
                                <td className="py-4 px-6">{row.NamaKaryawan || "-"}</td>
                                <td className="py-4 px-6">{row.JenisPerawatan || "-"}</td>
                                <td className="py-4 px-6">{row.NamaPenyakit || "-"}</td>
                                <td className="py-4 px-6 whitespace-nowrap">{fmtTgl(row.TanggalSakit)}</td>
                                <td className="py-4 px-6 whitespace-nowrap">{fmtTgl(row.TanggalSembuh)}</td>
                                <td className="py-4 px-6"><span className={statusClass(row.StatusKet)}>{row.StatusKet || "-"}</span></td>
                                <td className="py-4 px-6 text-xs"><CutiApprovalActors list={row.ApprovalList} /></td>
                                <td className="py-4 px-6 whitespace-nowrap">
                                  {["-1", "-2", "-3"].includes(row.Status) && (
                                    <>
                                      <button
                                        onClick={() => { handleModal({ showModalAdd: false, showModalEdit: true }); handleCurrentData(row); }}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2 mr-2"
                                      >
                                        Edit
                                      </button>
                                      <button
                                        onClick={() => handleKirim(row.SakitID)}
                                        className="border text-white bg-main-100 hover:bg-white hover:border-main-100 hover:text-main-100 font-medium rounded-lg text-sm px-4 py-2"
                                      >
                                        Kirim
                                      </button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filtered.length} data</span>
                      <div className="flex items-center gap-4">
                        <button onClick={() => setPageC((p) => Math.max(1, p - 1))} disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev</button>
                        <span>Page {safePage} / {totalPage}</span>
                        <button onClick={() => setPageC((p) => Math.min(totalPage, p + 1))} disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next</button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalAdd(false);
            setShowModalEdit(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />
            <div className="flex flex-wrap -mx-3 mb-6">
              <HrdInputGenerator
                type={"text"}
                size={"full"}
                name={"JenisPerawatan"}
                title={"Jenis Perawatan"}
                value={values}
                required={true}
                onChange={changeHandler}
                touched={touched}
                errors={errors}
              />
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <HrdInputGenerator
                type={"date"}
                name={"TanggalSakit"}
                title={"Tanggal Sakit"}
                value={values}
                required={true}
                onChange={customHandler}
                touched={touched}
                errors={errors}
              />
              <HrdInputGenerator
                type={"date"}
                name={"TanggalSembuh"}
                title={"Tanggal Sembuh"}
                value={values}
                required={true}
                onChange={customHandler}
                touched={touched}
                errors={errors}
              />
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <HrdInputGenerator
                type={"penyakit"}
                size={"full"}
                name={"PenyakitID"}
                title={"Penyakit"}
                value={values}
                required={true}
                onChange={customHandler}
                touched={touched}
                errors={errors}
              />
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <HrdInputGenerator
                type={"text"}
                name={"NamaRS"}
                title={"Nama RS"}
                value={values}
                required={true}
                onChange={changeHandler}
                touched={touched}
                errors={errors}
              />
              <HrdInputGenerator
                type={"text"}
                name={"NamaDokter"}
                title={"Nama Dokter"}
                value={values}
                required={true}
                onChange={changeHandler}
                touched={touched}
                errors={errors}
              />
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <HrdInputGenerator
                type={"file"}
                size={"full"}
                name={"FileSuratDokter"}
                title={"Surat Dokter"}
                value={values}
                required={true}
                onChange={customHandler}
                touched={touched}
                errors={errors}
              />
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              isValid || (showModalEdit && !isValid) ? "green" : "blueGray"
            }
            onClick={() => {
              let newValues = values;
              try {
                const { v4: uuidv4 } = require("uuid");

                const uuid = uuidv4();
                let formData = new FormData();
                const nama =
                  uuid +
                  "-" +
                  newValues["FileSuratDokter"].name.replaceAll(" ", "_");
                formData.append("file", newValues["FileSuratDokter"], nama);
                mutationFile.mutate(formData);
                newValues["FileSuratDokter"] = nama;
              } catch (error) {
                console.log(error);
              }

              let tempIsValid = true;
              if (tempIsValid) {
                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  dispatch(updateSakitTransaksi(Object.assign(newValues)));
                  reapprove();
                } else {
                  mutationInput.mutate(Object.assign(newValues), {
                    onSuccess: async (data, context) => {
                      toast.success(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      setShowModalAdd(false);
                      setShowModalEdit(false);
                      reapprove();
                    },
                    onError: async (data, context) => {
                      toast.error(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                    },
                  });
                }
              }
            }}
            ripple={isValid ? "light" : ""}
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SakitPage;
